<template>
  <div :class="$style.container">
    <div :class="$style.content">
      <div :class="$style.title">
        {{ displayTitle }}
      </div>
      <div :class="$style.toolbar">
        <div v-if="language" :class="$style.language">
          <localization-controller
            :language="language"
            inverted-color
          />
        </div>
        <div v-if="hasRedirect" :class="$style.redirect" @click="$emit('redirect-back')">
          <alert-circle-icon />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AlertCircleIcon from 'atoms/icons/notifications/AlertCircle';
import LocalizationController from 'organisms/localization/LocalizationController';

export default {
  name: 'PaymentHeader',
  components: {
    AlertCircleIcon,
    LocalizationController,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    language: {
      type: Object,
    },
    hasRedirect: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    displayTitle() {
      return this.title;
    },
  },
};
</script>

<style lang="sass" module>
  .container
    width: 100%
    position: relative
    padding: 14px 15px
    background-color: #000
    z-index: 5000

    +respond-to('medium')
      padding: 14px 30px

  .content
    display: flex
    align-items: center
    justify-content: space-between

  .title
    font-weight: 500
    font-size: 14px
    line-height: 22px
    color: #fff

  .toolbar
    display: flex

  .language
    flex: none
    cursor: pointer

  .redirect
    display: flex
    margin-left: 25px
</style>
